import React from 'react';

const resolveProfileImageUrl = (profileImage) => {
  if (!profileImage) return `${process.env.REACT_APP_SPACES_BASE}/user.png`;
  if (String(profileImage).startsWith('http://') || String(profileImage).startsWith('https://')) return profileImage;
  return `${process.env.REACT_APP_SPACES_BASE}/${profileImage}`;
};

const ContractorWizardModal = ({ wizardApi }) => {
  const {
    showWizard,
    closeWizard,
    wizard,
    setWizard,
    wizardErrors,
    isSaving,
    isValidating,
    runValidationStep,
    handleSave,
    renderLocalField,
    wizardPhoneFields,
    wizardDetailsFields,
    profileFileInputRef,
    uploadProfileImage,
  } = wizardApi;

  if (!showWizard) return null;

  return (
    <div className='modal show d-block' tabIndex='-1'>
      <div className={`modal-dialog ${wizard.step === 1 ? 'modal-md' : 'modal-lg'}`}>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              {wizard.step === 1 ? 'Enter Contractor Phone Number' : wizard.matchResult.status === 'none' ? 'Enter Contractor Details' : 'Confirm Contractor'}
            </h5>
            <button type='button' className='btn-close' onClick={closeWizard} />
          </div>
          <div className='modal-body'>
            {wizard.step === 1 && <div className='row g-3'>{wizardPhoneFields.map(renderLocalField)}</div>}
            {wizard.step === 2 && (
              <div>
                {(wizard.matchResult.status === 'none') && (
                  <div className='mb-3'>
                    <label className='form-label mb-8'>Profile Image</label>
                    {wizard.local.profileImage && (
                      <div className='mb-12'>
                        <img
                          src={resolveProfileImageUrl(wizard.local.profileImage)}
                          alt='Selected profile'
                          style={{ width: '64px', height: '64px', objectFit: 'cover', borderRadius: '50%', border: '1px solid #ddd' }}
                        />
                      </div>
                    )}
                    <div className='d-flex gap-2'>
                      <button type='button' className='btn btn-outline-primary btn-sm' onClick={() => profileFileInputRef.current?.click()}>
                        {wizard.local.profileImage ? 'Change Image' : 'Select Image'}
                      </button>
                      {wizard.local.profileImage && (
                        <button type='button' className='btn btn-outline-secondary btn-sm' onClick={() => setWizard((prev) => ({ ...prev, local: { ...prev.local, profileImage: '' } }))}>
                          Remove
                        </button>
                      )}
                    </div>
                    <input
                      ref={profileFileInputRef}
                      type='file'
                      className='d-none'
                      accept='image/*'
                      onChange={async (event) => {
                        const file = event.target.files?.[0];
                        if (!file) return;
                        await uploadProfileImage(file);
                      }}
                    />
                  </div>
                )}
                {wizard.matchResult.status === 'none' && <div className='row g-3'>{wizardDetailsFields.map(renderLocalField)}</div>}
                {wizard.matchResult.status !== 'none' && (
                  <>
                    <p className='mb-16 fw-bold'>We found an existing contractor with this phone number.</p>
                    <p>Confirm this is the correct person and supplier.</p>
                    {wizard.matchResult.candidates.map((candidate) => (
                      <label key={candidate.id} className='d-flex align-items-start gap-3 border rounded p-16 mb-2'>
                        <input
                          type='radio'
                          name='globalCandidate'
                          className='d-none'
                          checked={wizard.selectedMatchId === candidate.id}
                          onChange={() => setWizard((prev) => ({ ...prev, selectedMatchId: candidate.id }))}
                        />
                        <img src={candidate.profileImage} alt={candidate.name} style={{ width: '45px', height: '45px', objectFit: 'cover', borderRadius: '50%' }} />
                        <div className='flex-grow-1'>
                          <strong className='text-xl'>{candidate.name}</strong>
                          <div>{candidate.phone || '-'}</div>
                          {candidate.email && <div>{candidate.email}</div>}
                        </div>
                      </label>
                    ))}
                    <div className='row g-3'><div className='col-md-12'>{renderLocalField(wizardDetailsFields.find((f) => f.field === 'supplierId'))}</div></div>
                  </>
                )}
                {wizardErrors.selectedMatchId && <p className='text-danger mt-2 mb-0'>{wizardErrors.selectedMatchId}</p>}
              </div>
            )}
          </div>
          <div className='modal-footer'>
            {wizard.step > 1 && <button className='btn btn-secondary' onClick={() => setWizard((prev) => ({ ...prev, step: prev.step - 1 }))}>Back</button>}
            {wizard.step === 1 && <button className='btn btn-primary' onClick={runValidationStep} disabled={isValidating}>{isValidating ? 'Checking...' : 'Continue'}</button>}
            {wizard.step === 2 && <button className='btn btn-primary d-inline-flex align-items-center gap-2' onClick={handleSave} disabled={isSaving}>{isSaving && <span className='spinner-border spinner-border-sm' />}{wizard.matchResult.status === 'none' ? 'Save Contractor' : 'Confirm & Save'}</button>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractorWizardModal;
